export default __webpack_public_path__ + "static/media/ProductSans-Medium.cc43e3c4.woff";